import { useMemo } from 'react';
import {
  PRODUCT_CUP_ATTRIBUTE,
  PRODUCT_SIZE_ATTRIBUTE,
} from 'settings/productV2';
import {
  ProductKind,
  ProductType,
  ProductVariantsSkusType,
} from 'types/ProductPageV2/Products';

export function useProductSku(
  product: ProductType,
  skus: ProductVariantsSkusType,
  type: ProductKind,
  size?: string,
  cup?: string
): {
  selectedProduct?: ProductType;
} {
  const sku = findSku();
  const selectedProduct = useMemo(() => {
    const variantProduct = sku ? skus[sku] : undefined;
    if (!variantProduct) return undefined;

    const { Attributes: variantAttrs, ...restVariantProduct } = variantProduct;

    return {
      ...restVariantProduct,
      Attributes: {
        ...product.Attributes,
        ...variantAttrs,
      },
    };
  }, [sku, product, skus]);

  function findSku(): string | undefined {
    const skusKeys = Object.keys(skus);

    switch (type) {
      case 0:
        return skusKeys[0];
      case 1:
        return (
          size &&
          skusKeys.find((key: string) => {
            return skus[key].Attributes[PRODUCT_SIZE_ATTRIBUTE].Value === size;
          })
        );
      case 2:
        return (
          size &&
          cup &&
          skusKeys.find((key: string) => {
            return (
              skus[key].Attributes[PRODUCT_SIZE_ATTRIBUTE].Value === size &&
              skus[key].Attributes[PRODUCT_CUP_ATTRIBUTE]?.Value === cup
            );
          })
        );
    }
  }

  return {
    selectedProduct,
  };
}
